import { render, staticRenderFns } from "./PolicyDetails.vue?vue&type=template&id=c5a4b532"
import script from "./PolicyDetails.vue?vue&type=script&lang=js"
export * from "./PolicyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports